import { useState, useEffect } from 'react'
import Onboarding1 from '../../../../../assets/account/onboarding1.webp'
import Onboarding2 from '../../../../../assets/account/onboarding2.webp'
import Onboarding3 from '../../../../../assets/account/onboarding3.webp'
import ScoopBlack from '../../../../../assets/account/ScoopLogo-black.webp'
import { ScoopText, ScoopColumn, ScoopRow, ScoopCenter } from '../../../../ui'
import styles from './SideBanner.module.scss'

const SLIDES = [
    {
        image: Onboarding1,
        tip: 'Create beautiful, interactive charts that adapt to your business questions',
    },
    {
        image: Onboarding2,
        tip: 'Ask questions in plain English and get AI-powered insights instantly',
    },
    {
        image: Onboarding3,
        tip: 'Transform insights into presentation-ready slides automatically',
    },
]

export const SideBanner = () => {
    const [currentSlide, setCurrentSlide] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % SLIDES.length)
        }, 5000) // Change slide every 5 seconds

        return () => clearInterval(interval)
    }, [])

    return (
        <ScoopColumn className={styles.container}>
            <ScoopColumn className={styles.logoContainer}>
                <div className={styles.logoBox}>
                    <img className={styles.logoImage} src={ScoopBlack} alt={'Scoop Black'} />
                </div>
            </ScoopColumn>
            <ScoopColumn className={styles.contentColumn}>
                {/* Fixed size image container */}
                <div className={styles.imageContainer}>
                    {SLIDES.map((slide, index) => (
                        <img
                            key={index}
                            className={`${styles.slideImage} ${currentSlide === index ? styles.active : ''}`}
                            src={slide.image}
                            alt={`scoop-preview-${index + 1}`}
                        />
                    ))}
                </div>

                {/* Fixed height text container */}
                <ScoopCenter className={styles.textContainer}>
                    <ScoopText className={styles.tipText}>
                        <b>TIP:</b> {SLIDES[currentSlide].tip}
                    </ScoopText>
                </ScoopCenter>

                {/* Dots indicator */}
                <ScoopRow className={styles.dotsRow}>
                    {SLIDES.map((_, index) => (
                        <div
                            key={index}
                            onClick={() => setCurrentSlide(index)}
                            className={`${styles.dot} ${currentSlide === index ? styles.active : ''}`}
                        />
                    ))}
                </ScoopRow>
            </ScoopColumn>
        </ScoopColumn>
    )
}
